import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { ContribBiennaleFieldValidators } from './validators/contrib-biennale.field-validators';
import { ContribBiennaleWarningsService } from './warnings/contrib-biennale.warnings';

@NgModule({
    declarations: [],
    imports: [CommonModule, ReactiveFormsModule],
    providers: [ContribBiennaleFieldValidators, ContribBiennaleWarningsService],
})
export class ContribBiennaleFormModule {}
